export enum UserPages {
  INFORMATION = "information",
  ASSETS = "assets",
  DOCUMENTS = "documents",
  EXTERNAL_BOOKKEEPING = "external-bookkeeping",
  DATEV_IMPORT = "datev-import",
  ANSCHREIBEN = "anschreiben",
  INCOME_TAX_PREVIEW = "income-tax-preview",
}
